import { __assign } from "tslib";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash-es';
import onlyIf from '../../hocs/onlyIf';
import PanelCode from '../../components/handoff/PanelCode';
import { getSelectedElementCode } from '../../selectors/code';
import { getSelectedElement } from '../../selectors/handoff';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    if (!element) {
        return {};
    }
    return __assign({ element: element }, getSelectedElementCode(state));
}
export default compose(connect(mapStateToProps), onlyIf(function (_a) {
    var code = _a.code, currentLang = _a.currentLang;
    return !isEmpty(code[currentLang]);
}))(PanelCode);
